import React from 'react';
import { ActivityIndicator, Pressable, StyleSheet } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import { Text } from './Texte';
import { colors, formes, gradients, radius, spacing } from '../theme/tokens';

export interface BoutonPastilleProps {
  label: string;
  onPress: () => void;
  loading?: boolean;
  disabled?: boolean;
  testID?: string;
}

/**
 * Petit bouton au dégradé des appels à l'action, posé dans un en-tête (« Enregistrer »). La
 * pastille est basse, la zone de toucher fait 44 pt : on peut la viser du pouce sans qu'elle
 * prenne la place d'un grand bouton.
 */
export function BoutonPastille({ label, onPress, loading = false, disabled = false, testID }: BoutonPastilleProps) {
  const inactif = disabled || loading;
  return (
    <Pressable
      testID={testID}
      accessibilityRole="button"
      accessibilityLabel={label}
      accessibilityState={{ disabled: inactif, busy: loading }}
      disabled={inactif}
      onPress={onPress}
      style={styles.cible}
    >
      <LinearGradient
        colors={gradients.cta}
        start={{ x: 0, y: 0 }}
        end={{ x: 1, y: 0 }}
        style={[styles.pastille, disabled && styles.inactive]}
      >
        {loading ? (
          <ActivityIndicator testID={testID ? `${testID}-spinner` : undefined} size="small" color={colors.white} />
        ) : (
          <Text style={styles.label}>{label}</Text>
        )}
      </LinearGradient>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  cible: { minHeight: formes.cible, justifyContent: 'center' },
  pastille: {
    minHeight: 36,
    minWidth: 96,
    paddingHorizontal: spacing.lg,
    borderRadius: radius.pill,
    alignItems: 'center',
    justifyContent: 'center',
  },
  inactive: { opacity: 0.5 },
  label: { fontSize: 14, fontWeight: '800', color: colors.white },
});
